import { IonButton, IonCol, IonContent, IonGrid, IonInput, IonLabel, IonPage, IonRow, IonItem, IonCheckbox } from '@ionic/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";

import CreditPayDirect from '../../components/CreditPayDirect';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import UserTerms from "../../components/UserTerms";
import { OptionPages } from '../../models/apiModels';


interface HomeProps {
  user?: User | null,
  lan: string
}


const SwFundraiserDonateStart: React.FC<HomeProps> = (props) => {

  const history = useHistory();
  const siteText = translation()
  const lan = siteText.lan;
  const [paymentMode, setPaymentMode] = useState(0);
  const [terms, agreeTerms] = useState(false);
  const [userTerms, showUserTerms] = useState<boolean>(false);


  const formText = (key: any) => {
    let text: any = {};
    text.title = {
      fr: "Soutenir SwissDonations",
      en: "Support SwissDonations",
      de: "Unterstützen Sie SwissDonations "
    }
    text.firstName = {
      fr: "Prénom",
      en: "First Name",
      de: "Vorname"
    }
    text.lastName = {
      fr: "Nom",
      en: "Last Name",
      de: "Nachname"
    }
    text.email = {
      fr: "E-mail",
      en: "Email",
      de: "E-Mail-Adresse "
    }
    text.amount = {
      fr: "Combien voulez-vous donner ?",
      en: "How much would you like to donate?",
      de: "Wieviel möchten Sie spenden? "
    }
    text.action = {
      fr: "Donner",
      en: "Donate",
      de: "Spenden",
    }

    return text[key][lan.substring(lan.indexOf("/") + 1)]
  }

  /*Close open user terms  */
  const toggleUserTerms = () => {
    let current = userTerms;
    showUserTerms(!current);
  }



  let defaultData = {
    firstName: '',
    lastName: '',
    email: '',
    amount: 0
  }

  const [formData, setFormdata] = useState(defaultData)

  const updateFormData = (e: any, feild: any) => {
    setFormdata(Object.assign(formData, { [feild]: e.detail.value }))

  }


  const onSubmit = (e: any) => {
    e.preventDefault()
    let state = {
      user: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        token: null,
        id: 1
      },
      amount: formData.amount
    }
    history.push(`${lan}/support_us_transfer`, state)
  }


  if (paymentMode === 1) {
    return <CreditPayDirect changePaymentMethod={setPaymentMode} />

  } else {
    return (<>
      {!userTerms ?
        <IonPage>
          <Header user={props.user} />
          <IonContent >
            <IonGrid className='sw_sp_lg'>
              <IonRow className='ion-justify-content-center ion-align-items-center'>
                <IonCol sizeSm='10' sizeMd="8">
                  <h1 className='ion-text-center sw_mb_sm '>{formText("title")}</h1>
                  <form onSubmit={onSubmit}>
                    <IonRow className='nested_row' >
                      <IonCol sizeXs='12' sizeSm='6' >
                        <IonLabel>{formText("firstName")}</IonLabel>
                        <IonInput onIonChange={e => updateFormData(e, "firstName")} required className='ion-margin-top ion-margin-bottom' type='text' placeholder={formText("firstName")}></IonInput>
                      </IonCol>
                      <IonCol>
                        <IonLabel>{formText("lastName")}</IonLabel>
                        <IonInput onIonChange={e => updateFormData(e, "lastName")} required className='ion-margin-top ion-margin-bottom' type='text' placeholder={formText("lastName")}></IonInput></IonCol>
                    </IonRow>
                    <IonLabel>{formText("email")}</IonLabel>
                    <IonInput onIonChange={e => updateFormData(e, "email")} required className='ion-margin-top ion-margin-bottom' type='email' placeholder={formText("email")}></IonInput>
                    <IonLabel>{formText("amount")}</IonLabel>
                    <IonInput min={1} onIonChange={e => updateFormData(e, "amount")} required className='ion-margin-top ion-margin-bottom' type='number' placeholder='CHF'></IonInput>
                    <IonRow className='nested_row'>
                      <IonCol sizeMd="6">
                        <IonItem lines='none' className='borderedInput'>

                          <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                          <IonCheckbox checked={terms} onIonChange={() => { agreeTerms(!terms) }} />
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    <IonRow className='nested_row ion-margin-top'>
                      <IonCol>
                        
                    <IonButton disabled={!terms} type='submit' color="primary">{formText("action")}</IonButton>
                    <IonButton className='ion-margin-start' fill="outline" color="secondary" onClick={() => { setPaymentMode(1) }}>{siteText.creditAccountStartSecondary}</IonButton>                    
                      </IonCol>
                    </IonRow>
                    </form>
                </IonCol>
              </IonRow>
            </IonGrid>
            <Footer></Footer>
          </IonContent>
        </IonPage>
        : <UserTerms goBack={toggleUserTerms} ></UserTerms>}
    </>)
  }
}

export default SwFundraiserDonateStart
